export function HttpRequestInterceptor($injector, $q, calloutService) {
    'ngInject';

    const NO_INTERNET_ERROR = 'no-internet-connection';
    const NO_INTERNET_ERROR_MESSAGE = 'No internet connection available.  Please try again or contact the restaurant.';

    let _blockingCalloutService;

    function blockingCalloutService() {
        // If you inject above you get:
        // Error: [$injector:cdep] Circular dependency found: $http <- $templateRequest <- $compile <- blockingCalloutService <- httpRequestInterceptor <- $http <- $templateFactory <- $view <- $state
        if (!_blockingCalloutService) {
            _blockingCalloutService = $injector.get('blockingCalloutService');
        }
        return _blockingCalloutService;
    }

    function request(config) {
        return config;
    }

    function requestError(config) {
        config = calloutService.error();
        return $q.reject(config);
    }

    function _tryTrackException(message) {
        if (message && typeof trackException === 'function') {
            trackException(message, false);
        }
    }

    function _isToastError(res) {
        return typeof res === 'object' && res.data && (
            (res.data.error !== undefined && res.data.error !== null)
            || (res.data.messageKey !== undefined && res.data.messageKey !== null)
        );
    }

    /**
     * Sets the error and errorMessage properties from the corresponding fields of a
     * G2 error response if they exist for compatibility with error responses
     * from toastweb.
     */
    function _translateToLegacyToastError(res) {
        res.data.error = res.data.error || res.data.messageKey;
        res.data.errorMessage = res.data.errorMessage || res.data.message;
    }

    function response(res) {
        if (_isToastError(res)) {
            _translateToLegacyToastError(res);
            const error = res.data.error;
            _tryTrackException(error);

            const interceptorConfig = _getInterceptorConfig(res.config);

            if (!interceptorConfig.skipCallout) {
                const errorMessage = res.data.errorMessage;
                res = _displayCallout({ errorMessage, error, interceptorConfig });
            }

            return $q.reject(res);
        }
        return res;
    }

    /**
     * ensures all error responses are well formed
     * @param {object} res the response sent from the server. Well formed
     *                       errors should contain a human readable errorMessage
     *                       and a error code (used for tracking). Errors from G2
     *                       should contain message and messageKey instead.
     * @returns {object} a well formed response
     */
    function responseError(res) {
        let errorMessage, error;
        if (_isToastError(res)) {
            _translateToLegacyToastError(res);
            error = res.data.error;
            errorMessage = res.data.errorMessage;
        }
        else if (typeof res.status === 'number' && res.status <= 0) {
            // Note we can also get in here due to an incorrect Access-Control-Request-... header
            // from the server (i.e. missing allowed method).
            error = NO_INTERNET_ERROR;
            errorMessage = NO_INTERNET_ERROR_MESSAGE;
        }

        _tryTrackException(error);

        const interceptorConfig = _getInterceptorConfig(res.config);
        const refreshAble = res.status === 401 && !interceptorConfig.noRefresh;

        if (!(interceptorConfig.skipCallout || refreshAble)) {
            res = _displayCallout({ errorMessage, error, interceptorConfig });
        }

        return $q.reject(res);
    }

    function _displayCallout({ errorMessage, error, interceptorConfig }) {
        // To customize the blocking callout, caller needs to use a custom error handler
        // in conjunction with skipCallout = true.
        if (interceptorConfig.blockingCallout) {
            return blockingCalloutService().error(errorMessage, error);
        }

        return calloutService.error(errorMessage, error);
    }

    /**
     *
     * @param {*} config The request config passed in when $http was called
     */
    function _getInterceptorConfig(config = {}) {
        let interceptorConfig = config.interceptorConfig || {};

        // TODO refactor any $http calls that don't explicitly pass in interceptorConfig.
        // (note customer-authentication also sets config values)

        // Note noRefresh is used by customer-authentication.
        if (typeof config.noRefresh !== 'undefined') {
            interceptorConfig.noRefresh = config.noRefresh;
        }

        if (typeof config.skipCallout !== 'undefined') {
            interceptorConfig.skipCallout = config.skipCallout;
        }

        return interceptorConfig;
    }

    ///--------------------------------

    return {
        response: response,
        responseError: responseError,
        request: request,
        requestError: requestError
    };
}
